<template>
  <div style="padding: 100px 0; width: 100%; text-align: center; font-size: 4vw;">
    <p>{{url}}</p>
    <p>请复制链接到【电脑端浏览器】访问</p>
  </div>
</template>

<script>
  export default{
    name:"empty",
    data(){
      return {
        url: 'https://www.qushanghui.com.cn/userinfo#/login?shid='+this.$route.query.shid
      }
    }
  }
</script>

<style lang="less" scoped>
  
</style>
